import { Helmet } from 'react-helmet'
import { Button, FormLayout } from 'components/common'
import { AggregatorIcon } from 'components/icons'
import PriceAndInventory from 'components/functionAndjobs/priceAndInventory'
import { triggerAggregatorApiJob } from 'utils/api/functionAndJobApi'
import toast from 'react-hot-toast'
import { useState } from 'react'
import FtpSelectedBarcode from 'components/functionAndjobs/ftpSelectedBarcode'
import { handleError } from 'utils/helpers/handleError'

const FunctionAndJobs = () => {
  const [aggregatorApiLoading, setAggregatorApiLoading] = useState(false)

  const handleTriggerAggregatorApi = async () => {
    const loadingToast = toast.loading('Initializing Aggregator API Trigger', {
      duration: Infinity,
    })
    setAggregatorApiLoading(true)
    try {
      await triggerAggregatorApiJob()
      toast.success('Aggregator API Job Initiated', {
        id: loadingToast,
        duration: 3000,
      })
    } catch (error) {
      handleError(error, loadingToast)
    } finally {
      setAggregatorApiLoading(false)
    }
  }

  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Function & Jobs</title>
      </Helmet>

      <h1 className="title">Function & Jobs</h1>

      <div className="flex flex-col gap-5">
        <div className="gap-5 mid-md:flex">
          <FormLayout className="mid-md:w-1/2">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-full bg-sidebar-primary/10">
                <AggregatorIcon />
              </span>
              <div className="flex-1">
                <h3 className="text-sm font-bold text-sidebar-primary">
                  Trigger Aggregator API
                </h3>
                <p className="mb-3 text-xs text-gray-500">
                  Manually call the aggregator API job outside its regular
                  schedule
                </p>
                <Button
                  buttonText="Trigger Aggregator API"
                  className="w-52"
                  type="button"
                  onClick={handleTriggerAggregatorApi}
                  loading={aggregatorApiLoading}
                />
              </div>
            </div>
          </FormLayout>
        </div>

        {/* Price and Inventory  */}
        <PriceAndInventory />

        {/* Selected Barcode For FTP */}
        <FtpSelectedBarcode />
      </div>
    </>
  )
}

export default FunctionAndJobs
